var map = {
	"./AnyMobile.png": "6452",
	"./anydesk.png": "d210",
	"./suporte-01.jpg": "9a45",
	"./suporte-02.jpg": "5d73",
	"./suporte-02.webp": "6be8",
	"./teamviewer-2.png": "91ba",
	"./whtz.png": "5356"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4966";